









import { createComponent } from "@vue/composition-api";

import ResourceItemTable from "@/components/resource/ResourceItemTable.vue";
import { recepturaResource } from "@megarax/client/src/resources/plm/Receptura";

export default createComponent({
  components: { ResourceItemTable },
  setup(props, ctx) {
    return {
      resource: recepturaResource,
    };
  },
});
